import {Avatar, Box, Typography} from "@mui/material";
import {BORDER_RADIUS_INNER} from "../../../../../config/themes/theme";
import {IMessage} from "../../../store/api/aiAssistantApiSlice";
import {MaterialSymbol} from "react-material-symbols";
// import {useGetProfileQuery} from "../../../../../store/api/userApiSlice";

interface UserChatUIProps {
  message: IMessage;
}
export default function UserChatUI({message}: UserChatUIProps) {
  // const {data: userProfile} = useGetProfileQuery();

  return (
    <Box sx={STYLES.userChatContainer}>
      {/* <Box mt={0.5}>
        <Avatar
          sx={{width: 24, height: 24, bgcolor: "secondary.main"}}
          src={userProfile?.profile?.profilePicture}
        />
      </Box> */}
      <Box sx={STYLES.userChatContent}>
        <MaterialSymbol
          icon={"person_raised_hand"}
          size={18}
          fill
          style={{marginTop: "3px"}}
        />
        <Typography sx={STYLES.userChatContentText}>{message.value}</Typography>
      </Box>
    </Box>
  );
}

const STYLES = {
  userChatContainer: {
    display: "flex",
    justifyContent: "start",
    gap: 1,
    width: "100%",
  },
  userChatContent: {
    display: "flex",
    // alignItems: "center",
    gap: 1,
    width: "100%",
    bgcolor: "secondary.light",
    borderRadius: BORDER_RADIUS_INNER,
    px: 2,
    py: 1.25,
  },
  userChatContentText: {
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.5rem",
  },
};
